import { useExtendedRouter } from '@hooks/next-routing-wrappers';

/**
 * Hook: useRouterLocale
 *
 * This hook get the locale information from the router's query parameters.
 * It is compatible with both the App Router (`useParams` from `next/navigation`)
 * and the Pages Router (`useRouter` from `next/compat/router`).
 *
 * First tries to detect locale from the i18n translated path (e.g., /locuri-de-munca → 'ro', /jobs → 'en').
 * Then falls back to the [locale] route param from query.
 *
 * @returns {string | undefined} - The locale from the router's query parameters.
 *
 * @example
 * // Using in a component
 * const locale = useRouterLocale();
 * console.log(locale); // Outputs the locale ("ro", "en", "hu")
 */
export const useRouterLocale = () => {
  const { locale } = useExtendedRouter();
  return locale;
};
